
























import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import PromotionService from '@/services/PromotionService';

const promotionService = new PromotionService();

const Auth = namespace('Auth');
const Dialog = namespace('Dialog');

@Component
export default class AuthConnector extends Vue {
  @Auth.State
  public isLoggedIn!: boolean;

  @Auth.State
  public token!: string;

  @Auth.State
  public gameUrl!: string;

  @Auth.Action
  public login!: (payload: object) => {}

  public authLoading: boolean = false;

  @Auth.Action
  public logout!: () => {}

  @Dialog.Action
  public updateDialog!: (payload: { open: boolean; dialogType: string }) => {}

  public async loginFunction(payload: { username: string; password: string }) {
    try {
      this.authLoading = true;
      await this.login(payload);
      this.$store.dispatch('Dialog/updateDialog', { open: false, dialogType: '' });
      this.$store.commit('Snackbar/showNotification', { message: 'ลงชื่อเข้าใช้สำเร็จ', error: false });
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: e.message, error: true });
    }
    this.authLoading = false;
  }

  public notifyLogoutOnly() {
    this.$store.commit('Snackbar/showNotification', { message: 'ท่านเป็นสมาชิกอยู่แล้ว', error: true });
  }

  // eslint-disable-next-line class-methods-use-this
  async playGames() {
    promotionService.clearFortunewheelTurnover()
      .then(() => {
        window.location.href = this.gameUrl;
      })
      .catch((e) => {
        console.log(e);
      });
  }

  public async logoutFunction() {
    await this.logout();
  }
}
